import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorFields, CampaignEditorReducerCreator } from '../types';

export type SetCampaignEditorFieldPayload = {
  [K in keyof CampaignEditorFields]: { key: K; value: CampaignEditorFields[K] };
}[keyof CampaignEditorFields];

const setCampaignEditorField = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<SetCampaignEditorFieldPayload>) => {
    (state.fields as Record<string, unknown>)[action.payload.key] = action.payload.value;
  });

export default setCampaignEditorField;
